module.exports = __webpack_public_path__ + "static/media/icon-calendar-green.a57b6009.svg";